export const sundayGapContent = {
  eyebrow: "RESEARCH CASE STUDY • NIGHTTIME LEAKAGE",
  title: "The 10:14 PM Sunday Gap",
  lead: "Your office is closed. Your crew is asleep. Competitors route to voicemail.",
  body: "Our audit data shows 64.2% of uncaptured leads arrive outside 9-to-5 business hours. Without instant 26-second interception, these leads decay completely before Monday morning.",
}
